import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Automats as AutomatsService } from '../../../../services/Automats'
import styles from './Command.module.scss'
import classNames from 'classnames'
import { Button } from '../../../simples/Button'

const runButtonClassNames = {
    button: styles.runButton,
}

type Props = {
    automatId: number
    label: string
    command: string
}

export const CommandItem: FC<Props> = ({ automatId, label, command }) => {
    const { t } = useTranslation()
    const [status, setStatus] = useState('')

    const sendCommand = async () => {
        setStatus(t('47_Commands_dispatch'))

        await AutomatsService.sendCommand(automatId, command)

        setStatus(t('48_Commands_done'))
    }

    return (
        <div className={styles.tr}>
            <div className={classNames(styles.td, styles.commandName)}>
                {label}
            </div>
            <div className={classNames(styles.td, styles.commandStatus)}>
                {status}
            </div>
            <div className={classNames(styles.td, styles.commandRun)}>
                <Button classNames={runButtonClassNames} onClick={sendCommand}>
                    {t('49_Commands_run')}
                </Button>
            </div>
        </div>
    )
}
